module.exports = {"timezone":{"EST":"ET","PST":"PT"}}


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src426716145/src/modules/web/src/js/i18n/spanish/timezone.es.i18n.json
// module id = 1351
// module chunks = 0